import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'interconsulta.kioskLocked';

/** Tablet registration lock. Survives a refresh so the patient cannot leave by reloading. */
@Injectable({ providedIn: 'root' })
export class KioskService {
  readonly locked = signal(readLocked());

  lock(): void {
    sessionStorage.setItem(STORAGE_KEY, '1');
    this.locked.set(true);
  }

  unlock(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    this.locked.set(false);
  }
}

function readLocked(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
